import { FC } from 'react';
import { ActionFeed } from './components/action-feed';
import { useActions } from '../../hooks/use-actions';
import { PlaybookFilterBadge } from '../../components/playbook-filter-badge';

export const ActionFeedPage: FC = () => {
    return (
        <>
            <ActionFeedPageComponent />
        </>
    );
};

const ActionFeedPageComponent: FC = () => {
    const { prospectIdsWithActions, isLoadingActions, totalActionsCount, prospectIdsWithCompletedActions } =
        useActions();

    return (
        <ActionFeed
            prospectIds={prospectIdsWithActions}
            completedProspectIds={prospectIdsWithCompletedActions}
            isLoading={isLoadingActions}
            totalCount={totalActionsCount}
            filterElements={<PlaybookFilterBadge size="md" />}
        />
    );
};

export default ActionFeedPage;
